import React from "react";
import { Custom, Item, Progress } from "components";
import { useApp } from "context";
import { Grid } from "@mui/material";
import { IBroadcast } from "interfaces";
import { Enums, Store } from "utils";

type Props = {
  sx?: any;
  opened: boolean;
  items: IBroadcast[] | null;
  onClose?: () => void;
};

export const Reminder = (props: Props) => {
  const { t, theme, service } = useApp();
  const [increment, setIncrement] = React.useState(0);
  const [reminders, setReminders] = React.useState([]);

  const isClinic = Store.sessionStorage.isClinic();

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await service.broadcast.slice(
        Enums.EnumBroadcastType.Reminder,
        false
      );
      setReminders(response);
    };
    fetchData();
  }, [props.opened, increment]);

  async function handleAction(broadcast: IBroadcast) {
    isClinic
      ? await service.broadcast.delete(broadcast.broadcastId)
      : await service.broadcast.update(broadcast.broadcastId, true);
    setIncrement(increment + 1);
  }

  return (
    <>
      <Custom.Modal
        header={t.title.reminder}
        opened={props.opened}
        onClose={props.onClose}
      >
        <>
          <Grid
            container
            spacing={theme.margin.md}
            sx={{ position: "relative" }}
          >
            <Grid item xs={12}>
              {reminders && reminders.length > 0 ? (
                reminders.map((item: IBroadcast) => {
                  return (
                    <Item.Broadcast
                      key={item.broadcastId}
                      item={item}
                      action={true}
                      onAction={() => handleAction(item)}
                    />
                  );
                })
              ) : (
                <Progress.NoRecord
                  height={200}
                  message={t.message.placeholder.no_reminder}
                />
              )}
            </Grid>
          </Grid>
        </>
      </Custom.Modal>
    </>
  );
};
